import getClientId from "../../hooks/auth/clientIdHook";
import { v4 as uuidv4 } from 'uuid';

const LocalStorageService = (function () {
  let _service;
  function _getService() {
    if (!_service) {
      _service = this;
      return _service;
    }
    return _service;
  }
  function _setToken(tokenObj) {
    sessionStorage.setItem(
      `oidc.user:${process.env.REACT_APP_IDN_BASE_URL}:${getClientId()}`,
      JSON.stringify({
        access_token: tokenObj.access_token,
        refresh_token: tokenObj.refresh_token,
      })
    );
    localStorage.setItem("access_token", tokenObj.access_token);
    localStorage.setItem("refresh_token", tokenObj.refresh_token);
  }
  function _getAccessToken() {
    const tokenId = `oidc.user:${process.env.REACT_APP_IDN_BASE_URL
      }:${getClientId()}`;
    const tokenStr = sessionStorage.getItem(tokenId);
    let oidcStorage = null;
    if (tokenStr) {
      oidcStorage = JSON.parse(tokenStr);
    }
    return oidcStorage ? oidcStorage.access_token : null;
  }
  function _getRefreshToken() {
    const tokenId = `oidc.user:${process.env.REACT_APP_IDN_BASE_URL
      }:${getClientId()}`;
    const tokenStr = sessionStorage.getItem(tokenId);
    let oidcStorage = null;
    if (tokenStr) {
      oidcStorage = JSON.parse(tokenStr);
    }
    return oidcStorage ? oidcStorage.refresh_token : null;
  }
  function _clearToken() {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
  }
  function _getUserInfo(propertyName) {
    if (propertyName == "user_contactId") {
      try {
        const oidcStorage = JSON.parse(sessionStorage.getItem(`oidc.user:${process.env.REACT_APP_IDN_BASE_URL}:${getClientId()}`));
        const contactId = (!!oidcStorage && !!oidcStorage.profile && !!oidcStorage.profile.contact_id) ? oidcStorage.profile.contact_id : "";
        if (contactId) {
          return contactId;
        }
      } catch (error) {
      }
    }
    return localStorage.getItem(propertyName);
  }
  function _setWithExpiry(key, value, ttl) {
    const item = {
      value,
      expiry: new Date().getTime() + ttl,
    };
    localStorage.setItem(key, JSON.stringify(item));
  }
  function _getWithExpiry(key) {
    const itemString = window.localStorage.getItem(key);
    if (!itemString) return null;
    const item = JSON.parse(itemString);
    const isExpired = new Date().getTime() > item.expiry;
    if (isExpired) {
      localStorage.removeItem(key);
      return null;
    }
    return item.value;
  }
  function _getActivityInfo(propertyName) {
    return localStorage.getItem(propertyName);
  }
  function _setActivityInfo(pageTitle) {
    // window.ParentActivity = uuidv4();//localStorage.setItem("ParentActivity", uuidv4());
    // window.IsParentActivity = true;//localStorage.setItem("IsParentActivity", true);
    window.TitleOfPage = pageTitle;//localStorage.setItem("PageTitle", pageTitle);
  }
  function _getAppConfig(propertyName) {
    return localStorage.getItem(propertyName);
  }
  function _setAppConfig() {
    try {
      fetch(`${process.env.PUBLIC_URL}/appconfig.json`, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          localStorage.setItem("CentralWebClientRedirectUrlCommunityUser", data.CentralWebClientRedirectUrlCommunityUser ? data.CentralWebClientRedirectUrlCommunityUser : "");
        }).catch(error => {
          console.log("There is an issue of getting appconfig.")
        });
    } catch (error) {
      console.log("There is an issue of getting appconfig")
    }
  }
  return {
    getService: _getService,
    setToken: _setToken,
    getAccessToken: _getAccessToken,
    getRefreshToken: _getRefreshToken,
    getUserInfo: _getUserInfo,
    clearToken: _clearToken,
    setWithExpiry: _setWithExpiry,
    getWithExpiry: _getWithExpiry,
    getActivityInfo: _getActivityInfo,
    setActivityInfo: _setActivityInfo,
    getAppConfig: _getAppConfig,
    setAppConfig: _setAppConfig,
  };
})();
export default LocalStorageService;
